/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: Type your file description
 * @Author: Type your email address
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-12-02 15:52:05
 * @LastEditTime: 2023-05-18 17:00:36
 * @FilePath: /client-h5-v2/src/theme/zhilian/drak.ts
 */

export default {
  'name': 'zhilianDrak',
  // 默认全局背景色
  'default-global-bg-color': '#3c3b3e',
  // 纯文本颜色
  'kd-text-color': '#FFFFFF',
  'kd-text-hover-color': '#ccc',
  'kd-text-tips-color': '#909399',
  // 链接颜色
  'kd-link-color': '#2EA9FE',
  'kd-link-hover-color': '#0d93ef',
  'kd-link-active-color': '#0d93ef',
  // icon 颜色
  'kd-icon-color': '#ffffff',
  // 按钮
  'kd-btn-text-color': '#2EA9FE',
  'kd-btn-text-hover-color': '#2EA9FE',
  'kd-btn-bg-color': 'rgba(8, 41, 249, 0.2)',
  'kd-btn-bg-hover-color': 'rgba(8, 41, 249, 0.5)',
  'kd-btn-bd-color': 'rgba(8, 41, 249, 0.2)',
  'kd-btn-bd-hover-color': 'rgba(8, 41, 249, 0.5)',
  // 顶部导航
  'kd-nav-bg-color': 'rgba(0, 0, 0, 0.6)',
  'kd-nav-text-color': '#ffffff',
  'kd-nav-text-hover-color': '#cccccc',
  // 侧边栏
  'kd-slider-nav-bg-color': 'rgba(0, 0, 0, 0.6)',
  'kd-slider-nav-bd-color': 'rgba(0, 0, 0, 0.6)',
  'kd-slider-qlink-text-color': '#ffffff',
  'kd-slider-qlink-text-hover-color': '#70787F',
  'kd-slider-logo-text-color': '#ffffff',
  'kd-slider-qlink-bg-color': '#333F48',
  'kd-slider-qlink-bg-hover-color': '#70787F',
  // 对话区域header
  'kd-dialog-header-banner-text-color': '#ffffff',
  'kd-dialog-header-banner-bg-color': 'none',
  'kd-dialog-header-banner-bd-color': 'rgba(0,0,0, 0.75)',
  // 对话区域middle
  'kd-dialog-middle-bg-color': 'rgba(0,0,0, 0.6)',
  'kd-dialog-middle-bd-color': 'rgba(0,0,0, 0.6)',
  // 对话区域bottom（input框）
  'kd-input-wrap-bg-color': 'rgba(0,0,0, 0.6)',
  'kd-input-text-color': '#ffffff',
  'kd-input-bg-color': 'rgba(0,0,0, 0.6)',
  'kd-input-bd-color': '#cccccc',
  'kd-input-bd-hover-color': '#ffffff',
  // 对话答案模版
  'kd-template-bg-color': 'rgba(8, 41, 249, 0.2)',
  'kd-template-text-color': '#ffffff',
  'kd-template-body-color': '#ffffff',
  'kd-template-bd-color': 'rgba(8, 41, 249, 0.2)',
  // send 按钮（对话框主体）
  'kd-send-btn-text-color': '#ffffff',
  'kd-send-btn-bg-color': 'rgba(8, 41, 249, 0.6)',
  'kd-send-btn-bg-hover-color': 'rgba(8, 41, 249, 0.8)',
  'kd-send-btn-bd-color': 'rgba(8, 41, 249, 0.6)',
  'kd-send-btn-bd-hover-color': 'rgba(8, 41, 249, 0.8)',
  'kd-send-tips-text-color': '#AAA7A7',
  // survey模版主题
  'kd-survey-bg-color': 'rgba(8, 41, 249, 0.2)',
  'kd-survey-text-color': '#ffffff',
  // survey模版主题-单选框横向的样式
  'kd-survey-radio-text-color': '#FFFFFF',
  'kd-survey-radio-active-text-color': '#000000',
  'kd-survey-radio-bg-color': 'rgba(0,0,0,0)',
  'kd-survey-radio-active-bg-color': '#FFCA7A',
  'kd-survey-radio-bd-color': '#FFFFFF',
  'kd-survey-radio-active-bd-color': '#FFCA7A',
  // survey模版主题-多选框横向的样式
  'kd-survey-checkbox-text-color': '#FFFFFF',
  'kd-survey-checkbox-active-text-color': '#000000',
  'kd-survey-checkbox-bg-color': 'rgba(0,0,0,0)',
  'kd-survey-checkbox-active-bg-color': '#FFEBCC',
  'kd-survey-checkbox-bd-color': '#FFFFFF',
  'kd-survey-checkbox-active-bd-color': '#FFEBCC',
  // 智联-survey 客服满意度评价样式
  'kd-survey-zhilian-engineerInfo-bg-color': 'rgba(8, 41, 249, 0.2)',
  'kd-survey-zhilian-engineerInfo-text-color': '#fecf02',
  'kd-user-template-bg-color': '#3F8CFF'
}
